import header from 'src/app/shared/components/header/header.l10n';
import phone from 'src/app/shared/components/phone/phone.l10n';
import addOns from 'src/app/modules/booking/pages/add-ons/add-ons.l10n';
import autocomplete from 'src/app/modules/booking/components/autocomplete/autocomplete.l10n';
import centreServiceOption
  from 'src/app/modules/booking/components/centre-services/centre-service-option/centre-service-option.l10n';
import checkoutDetails from 'src/app/modules/booking/components/checkout-details/checkout-details.l10n';
import filter from 'src/app/modules/booking/components/search-panel/search.l10n';
import payment from 'src/app/modules/booking/components/payment/payment.l10n';
import searchResults from 'src/app/modules/booking/components/search-result/search-results.l10n';
import confirmation from 'src/app/modules/booking/pages/confirmation/confirmation.l10n';
import orderRoom from 'src/app/modules/booking/pages/order-room/order-room.l10n';
import manageBooking from 'src/app/modules/manage-booking/manage-booking.l10n';
import bookingReference from 'src/app/modules/manage-booking/pages/booking-reference/booking-reference.l10n';
import bookingReview from 'src/app/modules/manage-booking/pages/booking-review/booking-review.l10n';
import mapL10n from 'src/app/modules/map/components/map.l10n';
import bookingSummary from 'src/app/shared/components/booking-summary/booking-summary.l10n';
import datepicker from 'src/app/shared/components/datepicker/datepicker.l10n';
import error from 'src/app/shared/components/error/error.l10n';
import footer from 'src/app/shared/components/footer/footer.l10n';
import formError from 'src/app/shared/components/form-error/form-error.l10n';
import modal from 'src/app/shared/components/modal/modal.l10n';
import priceSortingDisabledModal
  from 'src/app/shared/components/price-sorting-disabled-modal/price-sorting-disabled-modal.l10n';
import reservationTimeoutExpiredModal
  from 'src/app/shared/components/reservation-timeout-expired-modal/reservation-timeout-expired-modal.l10n';
import roomCard from 'src/app/shared/components/room-card/room-card.l10n';
import timerWarning from 'src/app/shared/components/timer-warning/timer-warning.l10n';
import { errorsLocalizationData as errors } from 'src/app/shared/constants/errors.constants';
import {
  bookingLabels,
  buttonsLabels,
  commonLabels,
  commonPhrases,
  formLabels,
  roomLabels
} from 'src/app/shared/constants/l10n.constants';
import timeSelection from 'src/app/modules/booking/components/time-selection-dropdown/time-selection-dropdown.l10n';
import peopleSelection
  from 'src/app/modules/booking/components/people-selection-dropdown/people-selection-dropdown.component.l10n';
import eInvoiving from 'src/app/shared/modules/e-invoicing/e-invoicing.l10n'
import filterRooms from 'src/app/modules/booking/components/filter-rooms/filter-rooms.l10n';

const classes = [
  header,
  roomCard,
  errors,
  bookingSummary,
  datepicker,
  timerWarning,
  error,
  footer,
  modal,
  priceSortingDisabledModal,
  reservationTimeoutExpiredModal,
  roomCard,
  manageBooking,
  bookingReview,
  bookingReference,
  confirmation,
  orderRoom,
  addOns,
  autocomplete,
  centreServiceOption,
  checkoutDetails,
  filter,
  mapL10n,
  payment,
  searchResults,
  phone,
  eInvoiving,

  // common texts
  buttonsLabels,
  bookingLabels,
  formLabels,
  roomLabels,
  commonLabels,
  commonPhrases,
  formError,
  timeSelection,
  peopleSelection,
  filterRooms
];

export const getLocalizationItems = (): Record<string, unknown> => classes.reduce((currentValue, cls) => Object.assign({}, currentValue, cls), {});
